var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AdminForm',{attrs:{"config":_vm.config,"form":_vm.form,"isBusy":_vm.isBusy,"options":_vm.options},on:{"submit:create:success":_vm.postFile,"submit:update:success":_vm.postFile,"fetchOptions":_vm.fetchOptions,"resetOptions":_vm.resetOptions}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5255e3ee","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BusinessReturn/BusinessReturnForm.vue
// module id = 766
// module chunks = 0